// For use in 'Array.prototype.filter' so that nulls are filtered from the array type.
export default function <T>(item: T | null): item is T {
    return item !== null;
}
